import { User } from '@/shared/types/User';

export const getCreditsState = (credits: User['credits']) => {
  const {
    lipsync_free_minutes: { total: totalFreeLipSyncMinutes, used: usedFreeLipSyncMinutes },
    minutes: { total: totalMinutes, used: usedMinutes },
    video: { total: totalFreeVideos, used: usedFreeVideos },
  } = credits;

  const hasFreeLipSyncMinutes = totalFreeLipSyncMinutes - usedFreeLipSyncMinutes > 0;
  const hasFreeVideos = totalFreeVideos - usedFreeVideos > 0;
  const hasMinutes = totalMinutes - usedMinutes > 0;
  const availableMinutes = totalMinutes - usedMinutes;
  const availableFreeVideos = totalFreeVideos - usedFreeVideos;

  return {
    availableFreeVideos,
    availableMinutes,
    hasFreeLipSyncMinutes,
    hasFreeVideos,
    hasMinutes,
  };
};
